export const TAG_THEMES = {
  DEFAULT: 'default',
  INFO: 'info',
  LAVENDER: 'lavender',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
};
